// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"a0051d52","513":"cc754af0","703":"d8451fb4","787":"8012d548"}[chunkId] + ".chunk.js";
};